import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { constantes } from 'src/app/shared/components/constantes';

@Injectable({
  providedIn: 'root'
})
export class UtilService {
  nomeTemaAtual: string;

  constructor() {}

  async sleep(milliSeconds: number) {
    return new Promise((resolve) => setTimeout(resolve, milliSeconds));
  }

  validarCpf(cpf: string): boolean {
    let soma = 0;
    let resto;

    if (!cpf) {
      return false;
    }

    if (cpf === '00000000000') {
      return false;
    }
    for (let i = 1; i <= 9; i++) {
      soma = soma + Number(cpf.substring(i - 1, i)) * (11 - i);
    }
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) {
      resto = 0;
    }
    if (resto !== Number(cpf.substring(9, 10))) {
      return false;
    }
    soma = 0;
    for (let i = 1; i <= 10; i++) {
      soma = soma + Number(cpf.substring(i - 1, i)) * (12 - i);
    }
    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) {
      resto = 0;
    }
    if (resto !== Number(cpf.substring(10, 11))) {
      return false;
    }

    return true;
  }

  validarCNPJ(cnpj: any) {
    cnpj = cnpj.replace(/[^\d]+/g, '');

    if (cnpj === '') {
      return false;
    }

    if (cnpj.length !== 14) {
      return false;
    }

    // Elimina CNPJs invalidos conhecidos
    if (
      cnpj === '00000000000000' ||
      cnpj === '11111111111111' ||
      cnpj === '22222222222222' ||
      cnpj === '33333333333333' ||
      cnpj === '44444444444444' ||
      cnpj === '55555555555555' ||
      cnpj === '66666666666666' ||
      cnpj === '77777777777777' ||
      cnpj === '88888888888888' ||
      cnpj === '99999999999999'
    ) {
      return false;
    }

    // Valida DVs
    let tamanho = cnpj.length - 2;
    let numeros = cnpj.substring(0, tamanho);
    const digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) {
        pos = 9;
      }
    }
    let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado !== +digitos.charAt(0)) {
      return false;
    }

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) {
        pos = 9;
      }
    }
    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado !== +digitos.charAt(1)) {
      return false;
    }

    return true;
  }

  // aplicarTema(nomeTema: string, salvarLocal = true): void {
  //   const elem: any = document.getElementById('tema-app');
  //   const tema = `assets/themes/${nomeTema}.css`;
  //   if (elem) {
  //     elem.href = tema;
  //     this.nomeTemaAtual = nomeTema;
  //     if (salvarLocal) {
  //       localStorage.setItem(constantes.localStorage.temaSelecionado, nomeTema);
  //     }
  //   }
  // }

  verificarTemaLocal(): void {
    const item = localStorage.getItem(constantes.localStorage.temaSelecionado);
    if (item) {
      this.nomeTemaAtual = item;
      //this.aplicarTema(item);
    } else {
      this.nomeTemaAtual = 'light';
    }
  }

  // aplicarTemaLightSemSalvar(): void {
  //   this.aplicarTema('light', false);
  // }

  parseNomeMes(mes: string) {
    switch (mes) {
      case '1':
        return 'Janeiro';
      case '2':
        return 'Fevereiro';
      case '3':
        return 'Março';
      case '4':
        return 'Abril';
      case '5':
        return 'Maio';
      case '6':
        return 'Junho';
      case '7':
        return 'Julho';
      case '8':
        return 'Agosto';
      case '9':
        return 'Setembro';
      case '10':
        return 'Outubro';
      case '12':
        return 'Novembro';
      case '12':
        return 'Dezembro';

      default:
        return '';
    }
  }

  getObjectPropertyByStringPath(o: any, s: string) {
    try {
      s = s.replace(/\[(\w+)\]/g, '.$1');
      s = s.replace(/^\./, '');
      const a = s.split('.');
      for (let i = 0, n = a.length; i < n; ++i) {
        const k = a[i];
        if (k in o) {
          o = o[k];
        } else {
          return;
        }
      }
      return o;
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  removerAcentos(palavra: string) {
    let str = palavra;
    const mapaAcentosHex = {
      a: /[\xE0-\xE6]/g,
      e: /[\xE8-\xEB]/g,
      i: /[\xEC-\xEF]/g,
      o: /[\xF2-\xF6]/g,
      u: /[\xF9-\xFC]/g,
      c: /\xE7/g,
      n: /\xF1/g
    };

    for (const letra in mapaAcentosHex) {
      if (mapaAcentosHex.hasOwnProperty(letra)) {
        const expressaoRegular = mapaAcentosHex[letra];
        str = str.replace(expressaoRegular, letra);
      }
    }

    return str;
  }

  underEighteen(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (control.value.length >= 8) {
        const date = control.value.split('/');
        const birthDateString = `${date[2]}-${date[1]}-${date[0]}`;

        const today = new Date();
        const birthDate = new Date(birthDateString);
        let age = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
        return age < 18 ? { underAge: true } : null;
      } else {
        return null;
      }
    };
  }

  isNullOrUndefined(e: any) {
    return e === null || e === undefined || !e;
  }
}
